import { RouteEnum } from 'App/routes';
import { LoginPayload, VerificationPayload } from '../api';
import { Nullable, UserUI } from '@shared';

export type ContextValues = {
  initializing: boolean;
  authenticated: boolean;
  unauthenticated: boolean;
  unauthenticate: (doNavigate?: boolean) => void;
  login: ({ email, password }: LoginPayload) => Nullable<Promise<string | void>>;
  verification: ({ code }: VerificationPayload) => Nullable<Promise<string | void>>;
  logout: () => void;
  currentUser: UserUI;
  initialPage: { pathname: RouteEnum };
  isCredsEntered: boolean;
  status: SessionStatus;
};

export enum SessionStatus {
  Initializing = 'Initializing',
  Authenticated = 'Authenticated',
  Unauthenticated = 'Unauthenticated',
}
